import React from "react";
import { MenuItem, Box, Typography, useTheme } from "@mui/material";
import { getIcon } from "@dishopsaas/design-system";
import { useLocation } from "react-router-dom";
import { dropdown } from "../../InfoBar.styles";
import { MenuRowProps } from "../../../../1_types/InfoBarTypes";
import { descriptionText } from '../../InfoBar.styles'
export const MenuRow: React.FC<MenuRowProps> = ({
  label,
  icon,
  onClick,
  height = "36px",
  subLabel,
  color,
  path,
}) => {
  const theme = useTheme();
  const location = useLocation();
  const isActive = path ? location.pathname === path : false;

  return (
    <MenuItem
      onClick={onClick}
      sx={{
        ...dropdown,
        height,
        color,
        display: "flex",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          width: 20,
          minWidth: 20,
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        {getIcon(icon, {
          color: isActive ? theme.palette.primary.main : undefined,
        })}
      </Box>

      <Box sx={descriptionText}>
        <Typography variant="body1" fontWeight={subLabel ? 700 : 400} sx={{ color, ...descriptionText }}>
          {label}
        </Typography>

        {subLabel && (
          <Typography variant="caption" color="text.secondary" sx={descriptionText}>
            {subLabel}
          </Typography>
        )}
      </Box>
    </MenuItem>
  );
};
